<template>
    <v-container id="glossaire">
        <v-dialog v-model="photoDialog" max-width="1200px">
            <template v-if="photoSelected === 'typo_en.jpg'">
                <img src="../../assets/images/typo_en.jpg" alt="">
            </template>
            <template v-if="photoSelected === 'typo_pr.jpg'">
                <img src="../../assets/images/typo_pr.jpg" alt="">
            </template>
            <template v-if="photoSelected === 'typo_pu.jpg'">
                <img src="../../assets/images/typo_pu.jpg" alt="">
            </template>
        </v-dialog>
        <v-card>
            <v-card-title class="title_display" @click="show.glossaire=!show.glossaire">
                <v-layout justify-space-between>
                    <h2>
                        Glossaire
                    </h2>
                    <v-icon large right>
                        {{ show.glossaire ? 'arrow_drop_down' : 'arrow_left' }}
                    </v-icon>
                </v-layout>
            </v-card-title>

            <transition name="fade">
                <template v-if="show.glossaire">
                    <v-col>
                        <v-row>
                            <v-col align="center">
                                <img src="../../assets/images/typo_en.jpg" alt="" class="mid" @click="zoomPhoto('typo_en.jpg')">
                            </v-col>
                            <v-col align-self="center">
                                <h3>
                                    Enseigne
                                </h3>
                                <p>
                                    Une enseigne constitue toute inscription, forme ou image apposée sur un immeuble et relative à une activité qui s'y exerce.
                                </p>
                                <p class="ref-code">
                                    article L581-3-2 du code de l'environnement
                                </p>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col align-self="center">
                                <h3>
                                    Pré-enseigne
                                </h3>
                                <p>
                                    Une pré-enseigne constitue toute inscription, forme ou image indiquant la proximité d'un immeuble où s'exerce une activité déterminée
                                </p>
                                <p class="ref-code">
                                    article L581-3-1 du code de l'environnement
                                </p>
                            </v-col>
                            <v-col align="center">
                                <img src="../../assets/images/typo_pr.jpg" alt="" class="mid" @click="zoomPhoto('typo_pr.jpg')">
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col align="center">
                                <img src="../../assets/images/typo_pu.jpg" alt="" class="mid" @click="zoomPhoto('typo_pu.jpg')">
                            </v-col>
                            <v-col align-self="center">
                                <h3>
                                    Publicité
                                </h3>
                                <p>
                                    Une publicité constitue, à l'exclusion des enseignes et pré-enseignes, toute inscription, forme ou image, destinée à informer le public ou à attirer son attention. Les dispositifs dont le principal objet est de recevoir les dites inscriptions, formes ou images étant assimilées à des publicités.
                                </p>
                                <p class="ref-code">
                                    article L581-3-1 du code de l'environnement
                                </p>
                            </v-col>
                        </v-row>
                    </v-col>
                </template>
            </transition>
        </v-card>
    </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'Glossaire',
    components: {},
    mixins: [],
    props: {},
    data() {
        return {
            photoSelected: null,
            photoDialog: false,
        };
    },
    computed: {
        ...mapState('show', ['show']),
    },
    watch: {},
    created() {

    },
    methods: {
        zoomPhoto(photo) {
            this.photoSelected = photo;
            this.photoDialog = true;
        },
    },
}
</script>

<style scoped>
.mid {
    max-width: 50%;
    cursor: pointer;
    transition: all 0.25s ease-in;
}

.mid:hover {
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.05);
}
</style>



// WEBPACK FOOTER //
// src/components/Simulateur/Glossaire.vue